<h1 mat-dialog-title>{{ data?.title }}</h1>
<div mat-dialog-content>
  <p class="error-message" [innerHtml]="data?.message"></p>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close color="primary" (click)="onClose()">Close</button>
</div>
